module.exports = __webpack_public_path__ + "static/media/SaifeeEvents135.cb20b080.jpg";